export default class SimpleFavoriteTag {
  Id: number
  Tag: string
  Color: string
  CreatedByUserName: string
  CustomerId: number
  SharedUsers?: number[]
  SharedUsersGroups?: number[]

  constructor(Id: number, Tag: string, Color: string, createdByUserName: string, CustomerId: number, SharedUsers?: number[], SharedUsersGroups?: number[]) {
    this.Id = Id
    this.Tag = Tag
    this.Color = Color
    this.CreatedByUserName = createdByUserName
    this.SharedUsers = SharedUsers
    this.SharedUsersGroups = SharedUsersGroups
    this.CustomerId = CustomerId
  }
}
